Formatter.terminalIcon = function (m) {
  let icon = '../../images/terminals-default.svg';
  switch (m) {
    case 'Verifone VX820':
      icon = '../../images/terminals-vx820.svg';
      break;
    case 'Verifone P400':
      icon = '../../images/terminals-p400.svg';
      break;
    case 'Verifone V400M':
      icon = '../../images/terminals-v400m.svg';
      break;
    case 'PAX A35':
      icon = '../../images/terminals-a35.svg';
      break;
    case 'PAX A77':
      icon = '../../images/terminals-a77.svg';
      break;
    case 'PAX A920':
      icon = '../../images/terminals-a920.svg';
      break;
    case 'Sunmi P2 SE':
      icon = '../../images/terminals-p2se.svg';
      break;
    case 'Sunmi P2 Lite SE':
    case 'Sunmi P2 Lite SE HD':
      icon = '../../images/terminals-p2litese.svg';
      break;
    case 'Sunmi P2 Smartpad':
      icon = '../../images/terminals-p2smartpad.svg';
      break;
    case 'Sunmi P3 Air':
      icon = '../../images/terminals-p3air.svg';
      break;
    case 'Sunmi P3KH':
      icon = '../../images/terminals-p3kh.svg';
      break;
    case 'Sunmi P3H':
      icon = '../../images/terminals-p3h.svg';
      break;
    case 'Sunmi P3 Mix':
      icon = '../../images/terminals-p3mix.svg';
      break;
  }
  return icon;
};
//# sourceMappingURL=terminal.js.map
